<template>
  <div id="contendedor-regitrar-nueva-solicitud-obra">
    <v-form v-model="formularioValido" ref="registrarNuevaSolicitudObra">
      <v-row>
        <text-field
          v-model="solicitudObra.numeroMemorandum"
          label="Número Memorandum"
          cols="4"
          :rules="[mixReglas.requerido]"
        >
        </text-field>
        <date-picker
          v-model="solicitudObra.fechaMemorandum"
          label="Fecha Memorandum"
          cols="4"
          :rules="[mixReglas.requerido]"
        >
        </date-picker>
        <custom-text-area
          v-model="solicitudObra.meta"
          label="Meta">
        </custom-text-area>
        <custom-select
          v-model="solicitudObra.idMunicipio"
          label="Municipio"
          :items="getMunicipios"
          item-text="nombre"
          item-value="id"
          required
          cols="4"
        >
        </custom-select>
        <v-col
          cols="3">
          <v-switch
            v-model="solicitudObra.esCabecera"
            label="¿Es cabecera Municipal?"
            inset>
          </v-switch>
        </v-col>
        <text-field
          v-model="solicitudObra.localidad"
          label="Localidad"
          cols="4"
        >
        </text-field>
        <custom-select
          v-model="solicitudObra.tipoLocalidad"
          label="Tipo de Localidad"
          :items="itemsTiposLocalidad"
          cols="3"
        >
        </custom-select>
        <text-field
          v-model="solicitudObra.colonia"
          label="Colonia"
          cols="4"
        >
        </text-field>
        <text-field
          v-model="solicitudObra.unidadMetaFisica"
          label="Unidad Meta Física"
          cols="3"
        >
        </text-field>
        <text-field
          v-model.number="solicitudObra.metaFisica"
          type="number"
          label="Meta Física"
          cols="3"
        >
        </text-field>
        <text-field
          v-model="solicitudObra.beneficiariosTipo"
          label="Tipo de Beneficiarios"
          cols="3"
        >
        </text-field>
        <text-field
          v-model.number="solicitudObra.beneficiariosCantidad"
          type="number"
          label="Numero de Beneficiados"
          cols="3"
        >
        </text-field>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <custom-text-field
          v-model.number="solicitudObra.montoSolicitado"
          cols="3"
          label="Monto Solicitado"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoSolicitadoFederal"
          cols="3"
          label="Monto Solicitado Federal"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoSolicitadoEstatal"
          cols="3"
          label="Monto Solicitado Estatal"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoSolicitadoMunicipal"
          cols="3"
          label="Monto Solicitado Municipal"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoSolicitadoOtros"
          cols="3"
          label="Monto Solicitado Otros"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoInvertidoAnteriormente"
          cols="3"
          label="Monto Invertido Anteriormente"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoInvertidoAnteriormenteFederal"
          cols="3"
          label="Monto Invertido Anteriormente Federal"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoInvertidoAnteriormenteEstatal"
          cols="3"
          label="Monto Invertido Anteriormente Estatal"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoInvertidoAnteriormenteMunicipal"
          cols="3"
          label="Monto Invertido Anteriormente Municipal"
          es-dinero
        >
        </custom-text-field>
        <custom-text-field
          v-model.number="solicitudObra.montoInvertidoAnteriormenteOtros"
          cols="3"
          label="Monto Invertido Anteriormente Otros"
          es-dinero
        >
        </custom-text-field>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <text-field
          v-model="solicitudObra.numeroOficioSolicitud"
          cols="3"
          label="Número Oficio Solicitud"
        >
        </text-field>
        <date-picker
          v-model="solicitudObra.fechaOficioSolicitud"
          cols="3"
          label="Fecha Oficio Solicitud"
        >
        </date-picker>
        <custom-select
          v-model="solicitudObra.idFuenteFinanciera"
          label="Fuente financiera"
          :items="getFuentesFinancieras"
          item-text="nombre"
          item-value="id"
          required
          cols="4"
        >
        </custom-select>
        <text-field
          v-model="solicitudObra.clavePresupuestal"
          cols="6"
          label="Clave Presupuestal"
        >
        </text-field>
        <date-picker
          v-model="solicitudObra.fechaInicioObra"
          label="Fecha Inicio de Obra"
          cols="3"
        >
        </date-picker>
        <date-picker
          v-model="solicitudObra.fechaTerminoObra"
          label="Fecha Termino de Obra"
          cols="3"
        >
        </date-picker>
        <custom-select
          v-model="solicitudObra.modalidadEjecucion"
          label="Modalidad de Ejecución"
          :items="itemsModalidadEjecucion"
          cols="3"
        >
        </custom-select>
        <text-field
          v-model.number="solicitudObra.avanceFisicoEnero"
          type="number"
          label="Avance Físico Enero"
          prefix="%"
          cols="3"
        >
        </text-field>
        <text-field
          v-model.number="solicitudObra.avanceFisicoDiciembre"
          type="number"
          label="Avance Físico Diciembre"
          prefix="%"
          cols="2"
        >
        </text-field>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <custom-text-area
          v-model="solicitudObra.conceptosAEjecutar"
          label="Conceptos a Ejecutar"
        >
        </custom-text-area>
        <custom-select
          v-model="solicitudObra.tipoProyecto"
          label="Tipo de Proyecto"
          :items="itemsTipoProyecto"
          cols="6"
        >
      </custom-select>
      <custom-select
        v-model="solicitudObra.tipoObra"
        label="Tipo de Obra"
        :items="itemsTiposObra"
        required
        cols="6"
      >
      </custom-select>
      <custom-text-area
        v-model="solicitudObra.problematica"
        label="Problematica">
      </custom-text-area>
      <custom-text-area
        v-model="solicitudObra.justificacionTecnica"
        label="Justificación Técnica">
      </custom-text-area>
      <custom-text-area
        v-model="solicitudObra.justificacionSocial"
        label="Justificación Social">
      </custom-text-area>
      </v-row>
      <v-row>
        <v-col cols="6" class="px-2" align="center">
          <v-row justify="center" class="my-2">
            <h3 class="secondary--text">
              Imagen Microlocalización
            </h3>
          </v-row>
          <template>
            <template v-if="!rutaArchivoMicroLocalizacion">
              <v-row justify="center">
                <div
                  class="contenedor-imagen-agregar"
                  @click="$refs.seleccionarMicro.click()">
                  <v-img
                    src="@/assets/add-img-img.png"
                    contain
                    height="100"
                    width="100">
                  </v-img>
                </div>
              </v-row>
            </template>
            <template v-if="rutaArchivoMicroLocalizacion">
              <v-row justify="center">
                <v-img
                  :src="rutaArchivoMicroLocalizacion"
                  height="300"
                  width="300"
                  contain
                  class="blue-grey darken-4">
                  <div class="contenedor-imagenes-remover-imagen">
                    <v-btn
                      small
                      icon
                      dark
                      @click="removerMicroLocalizacion()">
                      <v-icon>
                        mdi-close-circle
                      </v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </v-row>
            </template>
          </template>
        </v-col>
        <v-col cols="6" class="px-2" align="center">
          <v-row justify="center" class="my-2">
            <h3 class="secondary--text">
              Imagen Macrolocalización
            </h3>
          </v-row>
          <template>
            <template v-if="!rutaArchivoMacroLocalizacion">
              <v-row justify="center">
                <div
                  class="contenedor-imagen-agregar"
                  @click="$refs.seleccionarMacro.click()">
                  <v-img
                    src="@/assets/add-img-img.png"
                    contain
                    height="100"
                    width="100">
                  </v-img>
                </div>
              </v-row>
            </template>
            <template v-if="rutaArchivoMacroLocalizacion">
              <v-row justify="center">
                <v-img
                  :src="rutaArchivoMacroLocalizacion"
                  height="300"
                  width="300"
                  contain
                  class="blue-grey darken-4">
                  <div class="contenedor-imagenes-remover-imagen">
                    <v-btn
                      small
                      icon
                      dark
                      @click="removerMacroLocalizacion()">
                      <v-icon>
                        mdi-close-circle
                      </v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </v-row>
            </template>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="(avance, index) in avanceFinanciero" :key="avance.mes"
          md="3">
          <CustomTextField
            v-model.number="avance.importe"
            :label="avance.mes"
            es-dinero
            @keyup="cancularAvanceFinanciero(avance, index)">
          </CustomTextField>
          <div>
            <div>
              <span>
                Avance:
              </span>
              <v-chip
                small>
                {{ avance.avance }}%
              </v-chip>
            </div>
            <div>
              <span>
                Av. acumulado
              </span>
              <v-chip
                small>
                {{ avance.avanceAcumulado }}%
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-row>
      <input
        type="file"
        ref="seleccionarMacro"
        id="anexoMacro"
        class="d-none"
        accept="image/jpeg, image/png, image/bmp"
        capture="camera"
        @change="seleccionMacro">
        <input
        type="file"
        ref="seleccionarMicro"
        id="anexoMicro"
        class="d-none"
        accept="image/jpeg, image/png, image/bmp"
        capture="camera"
        @change="seleccionMicro"
      >
    </v-form>
  </div>
</template>
<script>
import TextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomTextField from '@/components/inputs/TextFieldGreen.vue';
import mixSolicitudesObras from './mixSolicitudesObras';

export default {
  name: 'RegistrarNuevaSolicitudObra',
  mixins: [mixSolicitudesObras],
  components: {
    TextField,
    DatePicker,
    CustomSelect,
    CustomTextArea,
    CustomTextField,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      rutaArchivoMicroLocalizacion: null,
      rutaArchivoMacroLocalizacion: null,
      solicitudObra: {
        numeroMemorandum: '',
        fechaMemorandum: '',
        meta: '',
        clavePresupuestal: '',
        unidadMetaFisica: '',
        metaFisica: 0,
        beneficiariosTipo: '',
        beneficiariosCantidad: 0,
        montoSolicitado: 100000,
        montoSolicitadoFederal: 0,
        montoSolicitadoEstatal: 0,
        montoSolicitadoMunicipal: 0,
        montoSolicitadoOtros: 0,
        montoInvertidoAnteriormente: 0,
        montoInvertidoAnteriormenteFederal: 0,
        montoInvertidoAnteriormenteEstatal: 0,
        montoInvertidoAnteriormenteMunicipal: 0,
        montoInvertidoAnteriormenteOtros: 0,
        numeroOficioSolicitud: '',
        fechaOficioSolicitud: '',
        idFuenteFinanciera: '',
        idMunicipio: '',
        localidad: '',
        tipoLocalidad: '',
        colonia: '',
        fechaInicioObra: '',
        fechaTerminoObra: '',
        modalidadEjecucion: '',
        avanceFisicoEnero: 0,
        avanceFisicoDiciembre: 0,
        conceptosAEjecutar: '',
        esCabecera: false,
        tipoProyecto: '',
        tipoObra: '',
        problematica: '',
        justificacionTecnica: '',
        justificacionSocial: '',
        calendario: '',
        imagenMacrolocalizacion: null,
        imagenMicrolocalizacion: null,
      },
      avanceFinanciero: [
        {
          mes: 'Mes 1',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 2',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 3',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 4',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 5',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 6',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 7',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
        {
          mes: 'Mes 8',
          importe: 0,
          avance: 0,
          avanceAcumulado: 0,
        },
      ],
    };
  },
  methods: {
    seleccionMacro() {
      this.rutaArchivoMacroLocalizacion = URL.createObjectURL(
        document.getElementById('anexoMacro').files[0],
      );
    },
    seleccionMicro() {
      this.rutaArchivoMicroLocalizacion = URL.createObjectURL(
        document.getElementById('anexoMicro').files[0],
      );
    },
    removerMicroLocalizacion() {
      this.rutaArchivoMicroLocalizacion = null;
    },
    removerMacroLocalizacion() {
      this.rutaArchivoMacroLocalizacion = null;
    },
    cancularAvanceFinanciero(mes, index) {
      const { montoSolicitado } = this.solicitudObra;
      const importe = Number(mes.importe);
      const mesAnteriror = this.avanceFinanciero[index - 1];

      if (!montoSolicitado || montoSolicitado <= 0) return;

      if (importe <= 0) return;

      this.avanceFinanciero[index].avance = this.$numberRound(((importe / montoSolicitado) * 100));

      this.avanceFinanciero[index].avanceAcumulado = (mesAnteriror !== undefined)
        ? (mesAnteriror.avanceAcumulado + mes.avance)
        : mes.avance;
    },
    limpiarFormulario() {
      this.$refs.registrarNuevaSolicitudObra.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  watch: {
    formularioValido: {
      handler(valor) {
        this.$emit('formularioValido', valor);
      },
    },
    enviandoFormulario: {
      handler(valor) {
        this.$emit('enviandoFormulario', valor);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagen-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: .5rem;
  cursor: pointer;
}
.contenedor-imagen-agregar:hover {
  border: 2px solid #ccc;
}
</style>
